var map = {
	"./1.png": "EXZU",
	"./10.png": "+2US",
	"./11.png": "09wh",
	"./12.png": "PbEH",
	"./13.png": "B4kj",
	"./14.png": "U1VB",
	"./15.png": "ZyJ6",
	"./16.png": "+E7n",
	"./17.png": "vJVx",
	"./18.png": "jqgd",
	"./19.png": "Xn4b",
	"./2.png": "2x84",
	"./20.png": "Nvfj",
	"./21.png": "qix7",
	"./22.png": "w9sS",
	"./23.png": "zskw",
	"./24.png": "FqGv",
	"./25.png": "EqGj",
	"./26.png": "Ryhq",
	"./27.png": "xkee",
	"./28.png": "coIb",
	"./29.png": "HLrN",
	"./3.png": "rFq2",
	"./30.png": "ddTv",
	"./31.png": "+z/B",
	"./32.png": "CjlE",
	"./33.png": "FSRN",
	"./34.png": "gsLj",
	"./35.png": "sFOW",
	"./36.png": "tSOd",
	"./37.png": "k1mx",
	"./38.png": "PIws",
	"./39.png": "KC2+",
	"./4.png": "w3SK",
	"./40.png": "v6aT",
	"./41.png": "yjoT",
	"./42.png": "6rNG",
	"./43.png": "oBnk",
	"./44.png": "DvL0",
	"./45.png": "RW78",
	"./46.png": "axpc",
	"./47.png": "MZ/c",
	"./48.png": "1I5O",
	"./5.png": "raqA",
	"./6.png": "jPwE",
	"./7.png": "Onpv",
	"./8.png": "lEeo",
	"./9.png": "IwNH"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ScKE";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fifa2026/flag_icons nonrecursive \.png$
// module id = ScKE
// module chunks = 1